"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applicationUrls = exports.env = exports.isDevelopment = exports.serverSite = exports.isEu = exports.isUs = exports.isProduction = void 0;
const env = process.env.NODE_ENV_DEV || process.env.NODE_ENV_OVERRIDE || process.env.NODE_ENV || 'test';
exports.env = env;
const isProduction = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'eu';
exports.isProduction = isProduction;
const isUs = (process.env.NODE_ENV === 'production' || process.env.NODE_ENV_OVERRIDE === 'production');
exports.isUs = isUs;
const isEu = (process.env.NODE_ENV === 'eu' || process.env.NODE_ENV_OVERRIDE === 'eu');
exports.isEu = isEu;
const isDevelopment = process.env.NODE_ENV === undefined || process.env.NODE_ENV === '' || env === 'dev';
exports.isDevelopment = isDevelopment;
const serverSite = isEu ? 't11' : 't01';
exports.serverSite = serverSite;
const applicationUrls = {
    dev: 'https://localhost:8443',
    test: 'https://app-test.totango.com',
    production: 'https://app.totango.com',
    eu: 'https://app.totango.com',
};
exports.applicationUrls = applicationUrls;
//# sourceMappingURL=consts.js.map